import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createStationOilTankInfo, deleteStationOilTankInfo as _deleteStationOilTankInfo, deleteStationOilTankInfoByIds, updateStationOilTankInfo, updateAlermStationOilTankInfo, findStationOilTankInfo, getStationOilTankInfoList } from '@/api/bairun/stationOilTankInfo'; //  此处请自行替换地址

import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { getDict } from '@/utils/dictionary'; // 获取字典数据的func

var _this;

export default {
  name: 'StationOilTankInfo',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatGunList: function formatGunList(gunList) {
      var guns = '';

      if (gunList && gunList.length > 0) {
        gunList.forEach(function (item) {
          guns += item.oilGunNo + '、';
        });
      }

      return guns.length > 0 ? guns.substr(0, guns.length - 1) : '';
    },
    formatAlarmStatusTag: function formatAlarmStatusTag(bool) {
      if (bool != null) {
        return bool === 1 ? 'primary' : 'danger';
      } else {
        return 'info';
      }
    },
    formatAlarmStatusName: function formatAlarmStatusName(row) {
      var alarmText = '';
      var alarmJson = '';

      if (row.alarmStatus == 1) {
        return '正常';
      }

      if (row.alarmStatusName && row.alarmStatusName != '') {
        try {
          alarmJson = JSON.parse(row.alarmStatusName);
        } catch (e) {
          return alarmJson;
        }

        for (var i in alarmJson) {
          if (alarmJson[i] != '') {
            alarmText += alarmJson[i] + '，';
          }
        }

        if (alarmText.length > 0) {
          return alarmText.substr(0, alarmText.length - 1);
        }
      }

      return alarmText;
    },
    formatOilTankStatusTag: function formatOilTankStatusTag(bool) {
      if (bool != null) {
        return bool === 1 ? 'success' : bool === 2 ? 'danger' : bool === 3 ? 'warning' : 'info';
      } else {
        return 'info';
      }
    },
    formatOilTankStatusText: function formatOilTankStatusText(bool) {
      if (bool != null) {
        return bool === 1 ? '使用中' : bool === 2 ? '已关停' : bool === 3 ? '维护中' : '未知';
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getStationOilTankInfoList,
      stationBaseList: [],
      actionType: null,
      editType: null,
      oilTankStatusDict: [],
      oilCodeDict: [],
      dialogFormVisible: false,
      dialogStatusFormVisible: false,
      deleteVisible: false,
      innerVisible: false,
      childPage: 1,
      childPageSize: 10,
      childTotal: 0,
      multipleSelection: [],
      formData: {
        stationId: null,
        oilTankName: null,
        oilTankNo: null,
        tankNum: null,
        oilCode: null,
        oilTankStatus: 1,
        yeweiyiStatus: null,
        tankVolume: null,
        tankCapacity: null,
        safeCapacity: null,
        tankHeight: null,
        alarmOilHigh: null,
        alarmOilLow: null,
        oilHeight: null,
        preAlarmOilHigh: null,
        preAlarmOilLow: null,
        waterHeight: null,
        oilProportion: null,
        alarmWaterHigh: null,
        alarmHighTemperature: null,
        alarmLowTemperature: null,
        oilTankRemark: null
      },
      rules: {
        stationId: [{
          required: true,
          message: '请选择需要配置的油站',
          trigger: 'blur'
        }],
        oilTankName: [{
          required: true,
          message: '请输入油罐名',
          trigger: 'blur'
        }],
        tankNum: [{
          required: true,
          message: '请输入数字编号',
          trigger: 'blur'
        }],
        oilTankNo: [{
          required: true,
          message: '请输入油罐编号',
          trigger: 'blur'
        }],
        oilCode: [{
          required: true,
          message: '请选择油品',
          trigger: 'blur'
        }],
        yeweiyiStatus: [{
          required: true,
          message: '请选择接通状态',
          trigger: 'blur'
        }],
        producedAt: [{
          required: true,
          message: '请选择出厂日期',
          trigger: 'blur'
        }],
        tankVolume: [{
          required: true,
          message: '请输入油罐体积',
          trigger: 'blur'
        }],
        tankCapacity: [{
          required: true,
          message: '请输入油罐容量',
          trigger: 'blur'
        }],
        safeCapacity: [{
          required: true,
          message: '请输入油罐安全容量',
          trigger: 'blur'
        }],
        tankHeight: [{
          required: true,
          message: '请输入油罐实际高度',
          trigger: 'blur'
        }],
        alarmOilHigh: [{
          required: true,
          message: '请输入油罐报警油高度',
          trigger: 'blur'
        }],
        alarmOilLow: [{
          required: true,
          message: '请输入油罐报警油低度',
          trigger: 'blur'
        }],
        preAlarmOilHigh: [{
          required: true,
          message: '请输入油罐预警油高度',
          trigger: 'blur'
        }],
        preAlarmOilLow: [{
          required: true,
          message: '请输入油罐预警油低度',
          trigger: 'blur'
        }],
        alarmWaterHigh: [{
          required: true,
          message: '请输入油罐报警水高度',
          trigger: 'blur'
        }],
        alarmHighTemperature: [{
          required: true,
          message: '请输入油罐报警高气温',
          trigger: 'blur'
        }],
        alarmLowTemperature: [{
          required: true,
          message: '请输入油罐报警低气温',
          trigger: 'blur'
        }]
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.pageSize = 8;
                _context2.next = 3;
                return _this3.getTableData();

              case 3:
                _context2.next = 5;
                return _this3.setStartMap();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 8;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.onSubmit();
    },
    updateStationOilTankInfo: function updateStationOilTankInfo(row, type) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return findStationOilTankInfo({
                  ID: row.ID
                });

              case 2:
                res = _context3.sent;
                _this4.actionType = 'update';
                _this4.editType = type;

                if (res.code === 0) {
                  _this4.formData = res.data.resStationOilTankInfo;
                  _this4.dialogFormVisible = true;
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    updateAlermStationOilTankInfo: function updateAlermStationOilTankInfo(row, type) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return findStationOilTankInfo({
                  ID: row.ID
                });

              case 2:
                res = _context4.sent;
                _this5.actionType = 'update';
                _this5.editType = type;

                if (res.code === 0) {
                  _this5.formData = res.data.resStationOilTankInfo;
                  _this5.dialogFormVisible = true;
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.formData = {
        stationId: null,
        oilTankName: null,
        oilTankNo: null,
        tankNum: null,
        oilCode: null,
        oilTankStatus: 1,
        yeweiyiStatus: null,
        tankVolume: null,
        tankCapacity: null,
        safeCapacity: null,
        tankHeight: null,
        alarmOilHigh: null,
        alarmOilLow: null,
        oilHeight: null,
        preAlarmOilHigh: null,
        preAlarmOilLow: null,
        waterHeight: null,
        oilProportion: null,
        alarmWaterHigh: null,
        alarmHighTemperature: null,
        alarmLowTemperature: null,
        oilTankRemark: null
      };
    },
    // 百分比计算
    percentage: function percentage(oil, empty, water) {
      var total = oil + empty + water;
      var value = parseInt(oil / total * 100);
      return value + '%';
    },
    // 日期格式化
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    deleteStationOilTankInfo: function deleteStationOilTankInfo(row) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                row.visible = false;
                _context5.next = 3;
                return _deleteStationOilTankInfo({
                  ID: row.ID
                });

              case 3:
                res = _context5.sent;

                if (!(res.code === 0)) {
                  _context5.next = 9;
                  break;
                }

                _this6.$message({
                  type: 'success',
                  message: '删除成功'
                });

                if (_this6.tableData.length === 1 && _this6.page > 1) {
                  _this6.page--;
                }

                _context5.next = 9;
                return _this6.getTableData();

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    checkedChange: function checkedChange(val, row) {
      var that = this;

      if (val == false) {
        that.multipleSelection.forEach(function (item, index) {
          if (item.ID == row.ID) {
            that.multipleSelection.splice(index, 1);
          }
        });
        return;
      }

      that.multipleSelection.push(row);
    },
    onBatchDeleteStationOilTankInfo: function onBatchDeleteStationOilTankInfo() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var ids, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                ids = [];
                _this7.multipleSelection && _this7.multipleSelection.map(function (item) {
                  ids.push(item.ID);
                });
                _context6.next = 4;
                return deleteStationOilTankInfoByIds({
                  ids: ids
                });

              case 4:
                res = _context6.sent;

                if (!(res.code === 0)) {
                  _context6.next = 11;
                  break;
                }

                _this7.$message({
                  type: 'success',
                  message: '删除成功'
                });

                if (_this7.tableData.length === ids.length) {
                  _this7.page--;
                }

                _this7.deleteVisible = false;
                _context6.next = 11;
                return _this7.getTableData();

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    enterDialog: function enterDialog() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this8.$refs['elForm'].validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(valid) {
                    var res;
                    return regeneratorRuntime.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            if (valid) {
                              _context7.next = 2;
                              break;
                            }

                            return _context7.abrupt("return");

                          case 2:
                            if (!(_this8.editType == 'warn')) {
                              _context7.next = 12;
                              break;
                            }

                            _context7.next = 5;
                            return updateAlermStationOilTankInfo(_this8.formData);

                          case 5:
                            res = _context7.sent;

                            if (!(res.code === 0)) {
                              _context7.next = 11;
                              break;
                            }

                            _this8.$message({
                              type: 'success',
                              message: '操作成功'
                            });

                            _this8.closeDialog();

                            _context7.next = 11;
                            return _this8.getTableData();

                          case 11:
                            return _context7.abrupt("return");

                          case 12:
                            _context7.t0 = _this8.actionType;
                            _context7.next = _context7.t0 === 'create' ? 15 : _context7.t0 === 'update' ? 19 : 23;
                            break;

                          case 15:
                            _context7.next = 17;
                            return createStationOilTankInfo(_this8.formData);

                          case 17:
                            res = _context7.sent;
                            return _context7.abrupt("break", 25);

                          case 19:
                            _context7.next = 21;
                            return updateStationOilTankInfo(_this8.formData);

                          case 21:
                            res = _context7.sent;
                            return _context7.abrupt("break", 25);

                          case 23:
                            _this8.$message({
                              type: 'info',
                              message: '无效操作'
                            });

                            return _context7.abrupt("return");

                          case 25:
                            if (!(res.code === 0)) {
                              _context7.next = 30;
                              break;
                            }

                            _this8.$message({
                              type: 'success',
                              message: '操作成功'
                            });

                            _this8.closeDialog();

                            _context7.next = 30;
                            return _this8.getTableData();

                          case 30:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    // 唤起弹窗 新增油罐基础信息
    openAddStationOilTankInfoDialog: function openAddStationOilTankInfoDialog() {
      this.actionType = 'create';
      this.editType = 'add';
      this.dialogFormVisible = true;
    },
    setStartMap: function setStartMap() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var stationBaseData;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return getDict('oilTankStatus');

              case 2:
                _this9.oilTankStatusDict = _context9.sent;
                _context9.next = 5;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  dataType: 'simpleFields'
                });

              case 5:
                stationBaseData = _context9.sent;
                _this9.stationBaseList = stationBaseData.data.list;
                _context9.next = 9;
                return getDict('oilCode');

              case 9:
                _this9.oilCodeDict = _context9.sent;

              case 10:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    }
  }
};